<script lang="ts">
    import { onMount } from 'svelte'
    import type { ManagerEntity } from '../../modules/usersApi/managers/manager.entity'
    import type { MedialistEntity } from '../../modules/toolsApi/academy/medialists/medialist.entity'
    import Zchat from '../_common/z/zchat/zchat.svelte'
    import type { ZChatContactEntity, ZChatMessageEntity } from '../_common/z/zchat/zchat'
    import AccountSupportPlayer from './account-support-player.svelte'

    let contacts: ZChatContactEntity[] = []

    let zchat = null

    async function load() {
        let conEMail: ZChatContactEntity = {
            id: '0:email',
            name: 'E-mail de suporte',
            phone: null,
            label: 'Plantão de urgências',
            status: 'Este contato não tira dúvidas.',
            photo: '/img/24hrs.png',
            type: 'email',
            messages: [
                {
                    isMe: false,
                    text: 'Olá!\n\nEste é o e-mail de nosso plantão: suporte@zandu.com.br\n\nEste e-mail não tira dúvidas.\nUtilize apenas para urgências relacionadas à estabilidade da plataforma fora do horário comercial e dias não úteis.\n\nDúvidas sobre o uso da plataforma, configurações e outros temas você deve enviar para nosso atendimento através do WhatsApp.',
                    time: new Date(),
                    type: 'text',
                    id: null,
                },
            ],
        }
        let conFinan: ZChatContactEntity = {
            id: '1:email',
            name: 'E-mail do Financeiro',
            phone: null,
            label: 'Setor Financeiro',
            status: 'Setor Financeiro',
            photo: '/img/finan.png',
            type: 'email',
            messages: [
                {
                    isMe: false,
                    text: 'Oi!\n\nEste é o e-mail de nosso financeiro: financeiro@zandu.com.br\n\nUtilize este e-mail para todas as questões financeiras envolvendo sua assinatura.\n\n- Pagamento de mensalidades\n- Dúvidas sobre faturas\n- Outros assuntos financeiros\n\nDisponível de segunda a sexta-feira em horário comercial.',
                    time: new Date(),
                    type: 'text',
                    id: null,
                },
            ],
        }
        let conAcademy: ZChatContactEntity = {
            id: '2:media',
            name: 'Zandu Academy',
            phone: null,
            label: 'Treinamentos e tutoriais',
            status: 'Treinamentos e tutoriais',
            photo: '/img/academy-icon.png',
            type: 'media',
            messages: [],
        }
        conAcademy.messages = await loadAcademy()
        contacts.push(conEMail)
        contacts.push(conFinan)
        contacts.push(conAcademy)

        //
        const manager: ManagerEntity = await window.api.users.users.getManager()
        if (!manager) return

        let conManager: ZChatContactEntity = {
            id: manager.managerId,
            name: manager.name,
            phone: manager.phone,
            label: 'Sucesso do Cliente',
            status: 'Sucesso do Cliente',
            photo: manager.photo,
            type: 'whatsapp',
            messages: [
                {
                    isMe: false,
                    text:
                        'Olá! Sou o consultor selecionado para atender você sempre que precisar.\nEstou disponível lá no WhatsApp para tirar suas dúvidas.\n\nMeu WhatsApp: ' +
                        window.api.utils.utils.phoneFriendly(manager.phone),
                    time: new Date(),
                    type: 'text',
                    id: null,
                },
            ],
        }
        contacts.unshift(conManager)
    }

    let medialists: MedialistEntity[] = []
    async function loadAcademy() {
        medialists = await window.api.tools.academy.medialists.getAllPublic({ type: 'video', media: true })
        console.log('medialists', medialists)
        let messages: ZChatMessageEntity[] = []
        for (const item of medialists) {
            messages.push({
                isMe: false,
                type: 'playlist',
                text: item.thumbnailUrl || '/img/academy-icon.png',
                label: '##### ' + item.title + '\n' + item.description,
                time: null,
                id: item.medialistId,
            })
        }
        messages.push({
            isMe: false,
            type: 'text',
            text: 'Todas as semanas estamos produzindo novos conteúdos para o Academy.\nVolte aqui de tempos em tempos para ver as novidades!',
            time: new Date(),
            id: null,
        })

        return messages
    }

    onMount(async () => {
        await load()
        await zchat.setChat(contacts[0].id)
    })

    let playlist: MedialistEntity
    function onOpen(ev) {
        const message: ZChatMessageEntity = ev.detail
        if (message.type === 'playlist') {
            playlist = medialists.find((m) => m.medialistId === message.id)
        }
        console.log('onOpen', ev.detail, playlist)
    }
</script>

{#if playlist}
    <AccountSupportPlayer on:close={() => (playlist = null)} {playlist}></AccountSupportPlayer>
{/if}
<div class="root-content p-3">
    <Zchat bind:this={zchat} {contacts} on:open={onOpen}></Zchat>
</div>
